export default "__VITE_ASSET__Dt2r193O__"